export const CampaignGoal = {
    GET_NEW_PUBLISHERS: 0,
    ACTIVE_OLD_PUBLISHERS: 1,
    INCREASE_SALE: 2,
    INCREASE_LEAD: 3,
    NOTIFICATION: 4,
}

export const CampaignTarget = {
    PUBLISHER_MEDIA_TYPE: 0,
    PUBLISHER_MEDIA_LEVEL: 1,
    PUBLISHER_FAVORITES: 3,
    PUBLISHER_LOCATION: 4,
    PRODUCT_CATEGORIES: 5,
}

export const CampaignPlan = {
    IN_APP: 0,
    EMAIL: 1,
    SMS: 2,
    BLOG_POST: 3,
    REPORTAGE: 4,
    RETARGET: 5,
    TOP_STORE: 6,
    STORE_OF_THE_WEEK: 7,
    AFFILI_TELEGRAM_CHANNEL: 8,
    AFFILI_INSTAGRAM_PAGE: 9,
}

export const CampaignPlanEMailType = {
    EXCLUSIVE: 0,
    WEEKLY_NEWSLETTER: 1,
    MONTHLY_NEWSLETTER: 2,
}

export const CampaignPlanInstagramAdType = {
    STORY: 0,
    POST: 1,
}

export const CampaignStatus = {
    PENDING: 0,
    APPROVED: 1,
    RUNNING: 2,
    STOPPED: 3,
    CANCELLED: 4,
    FINISHED: 20,
}